import React from "react";
import {
	Grid,
} from "@mui/material";
import {

} from "@mui/styles";
import {
	FaqItems,
	SearchInput,
	SectionItems
} from "./components";
import getTrans from "../../../languages/getTrans";

class Dashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			popularServices
		} = this.props;
		return (
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<SearchInput/>
				</Grid>
				<Grid item xs={12}>
					<SectionItems
						type="activation"
						items={popularServices}
						title={getTrans('dashboard.Популярные сервисы')}
						Icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M13.4419 1.67329C13.3494 1.59642 13.2398 1.5429 13.1224 1.51726C13.0049 1.49161 12.883 1.49459 12.7669 1.52593C12.6508 1.55727 12.544 1.61606 12.4554 1.69734C12.3668 1.77862 12.299 1.88002 12.2578 1.99297L10.1953 7.65641L7.93031 5.46172C7.85425 5.38795 7.76341 5.33113 7.66379 5.29501C7.56417 5.25889 7.45802 5.24429 7.35235 5.25217C7.24667 5.26005 7.14387 5.29024 7.05071 5.34074C6.95755 5.39124 6.87615 5.46091 6.81188 5.54516C4.78125 8.20579 3.75 10.8823 3.75 13.4998C3.75 15.6879 4.61919 17.7863 6.16637 19.3335C7.71354 20.8807 9.81196 21.7498 12 21.7498C14.188 21.7498 16.2865 20.8807 17.8336 19.3335C19.3808 17.7863 20.25 15.6879 20.25 13.4998C20.25 7.92641 15.4884 3.37485 13.4419 1.67329ZM17.2397 14.3755C17.0452 15.4618 16.5226 16.4624 15.7422 17.2426C14.9618 18.0229 13.961 18.5453 12.8747 18.7395C12.8335 18.7466 12.7918 18.75 12.75 18.7498C12.5619 18.7498 12.3806 18.679 12.2422 18.5516C12.1038 18.4242 12.0183 18.2494 12.0028 18.0619C11.9872 17.8745 12.0426 17.688 12.1581 17.5394C12.2736 17.3909 12.4407 17.2913 12.6262 17.2602C14.1797 16.9986 15.4978 15.6805 15.7612 14.1242C15.7946 13.928 15.9045 13.7531 16.0667 13.638C16.229 13.5228 16.4304 13.4768 16.6266 13.5102C16.8227 13.5435 16.9976 13.6534 17.1128 13.8156C17.228 13.9779 17.2739 14.1793 17.2406 14.3755H17.2397Z" fill="#FB7800"/>
						</svg>}
					/>
				</Grid>
				<Grid item xs={12}>
					<FaqItems/>
				</Grid>
			</Grid>
		)
	}
}

export default Dashboard;
